export default __webpack_public_path__ + "static/media/fly by night.f847e550.png";